import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Grid2 } from '@mui/material';
import Profilepage from '../../../../components/component/Vendor-Component/Profile/Profile-page';
import AddressDetailsCard from './Card/AddressDetailsCard';
import KycDetails from './Card/KycDetails';
import userContext from '../../../../configs/context/context';

export default function Profilevendor() {
	const { slug } = useParams();
	const { Vendorme } = useContext<any>(userContext);
	console.log(Vendorme, 'VendorMe');

	return (
		<>
			<Grid2 container spacing={2}>
				<Grid2 size={{ xs: 12, sm: 6 }}>
					<Profilepage slug={slug} Vendorme={Vendorme} />
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 6 }}>
					<AddressDetailsCard Vendorme={Vendorme} />
				</Grid2>
				<Grid2 size={{ xs: 12, sm: 12 }}>
					<KycDetails />
				</Grid2>
			</Grid2>
		</>
	);
}
